(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wondarize-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class WondarizeHero extends HTMLElement {
    connectedCallback() {
      this.current = 0;
      this.animating = false;
      this.slides = Array.from(this.querySelectorAll('.wondarize-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.wondarize-hero__dot'));
      this.counter = this.querySelector('.wondarize-hero__counter');
      this.count = this.slides.length;

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.goTo(i));
      });

      const speed = parseInt(this.dataset.autoplay || '0', 10);
      if (speed > 0 && this.count > 1) {
        const startTimer = () => {
          this._timer = setInterval(() => this.goTo((this.current + 1) % this.count), speed);
        };
        startTimer();
        this.addEventListener('mouseenter', () => clearInterval(this._timer));
        this.addEventListener('mouseleave', startTimer);
      }
    }

    goTo(index) {
      if (index === this.current || this.animating || !this.slides[index]) return;
      this.animating = true;

      const outSlide = this.slides[this.current];
      const inSlide = this.slides[index];

      // Clean up any leftover enter class from a previous transition
      outSlide.classList.remove('wh-entering');

      // Phase 1: animate out the current slide's elements
      outSlide.classList.add('wh-leaving');

      // Phase 2: after exit finishes, switch to new slide and animate in
      setTimeout(() => {
        outSlide.classList.remove('is-active', 'wh-leaving', 'wh-entering');
        inSlide.classList.add('is-active', 'wh-entering');

        this.current = index;
        this._updateNav();

        // Allow next transition after enter animation completes
        setTimeout(() => { this.animating = false; }, 550);
      }, 430);
    }

    _updateNav() {
      this.dots.forEach((dot, i) => {
        const active = i === this.current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      if (this.counter) {
        const n = String(this.current + 1).padStart(2, '0');
        const total = String(this.count).padStart(2, '0');
        this.counter.textContent = n + ' / ' + total;
      }
    }
  }

  if (!customElements.get('wondarize-hero')) {
    customElements.define('wondarize-hero', WondarizeHero);
  }

  } catch(e) { console.error(e); }
})();
})();
